import React, { FC } from 'react';
import { Box, Divider } from '@wix/design-system';
import { ErrorBoundary } from 'react-error-boundary';
import ErrorFallback from '../../../ErrorFallback';
import Review from '../../Review';
import { ReviewProps } from '../../types';

export type ReviewsTextKeys = Record<
  'viewReviewSubjectCTA' | 'replyAuthorTitle' | 'noReviews',
  string
>;

const PaddedReview: FC<ReviewProps> = ({
  review,
  isMyProfile,
  services,
  handleBiGenericClick,
  showDivider,
  i18nKeys,
  isMobileView,
  replyProps,
  onEdit,
  userReview,
  ReviewHeader,
  className,
  reviewStyles,
}) => {
  return (
    <Box className={className} display="block" paddingTop="SP4">
      <ErrorBoundary FallbackComponent={ErrorFallback}>
        <Review
          i18nKeys={i18nKeys}
          review={review}
          isMyProfile={isMyProfile}
          services={services}
          handleBiGenericClick={handleBiGenericClick}
          isMobileView={isMobileView}
          replyProps={replyProps}
          onEdit={onEdit}
          userReview={userReview}
          ReviewHeader={ReviewHeader}
          reviewStyles={reviewStyles}
        />
        {showDivider ? (
          <Box display="block" paddingTop="SP4">
            <Divider />
          </Box>
        ) : (
          <Box display="block" paddingTop="SP4"></Box>
        )}
      </ErrorBoundary>
    </Box>
  );
};

export default PaddedReview;
